module.exports = __webpack_public_path__ + "static/media/drive-together-logo.c22f32e6.svg";